import { createRequest, handleErrorCatchLog } from '../Helpers/GenericHelpers'
import requestToken from '../Services/TokenService'
import { setTokenToSessionStorage, getTokenFromSessionStorage } from '../Helpers/TokenHelper'
import { AuthRequest } from '../Interfaces/AuthRequest'

type GetIntegrationOptionPayloadRequest = {
  utente: string
  key: string
}

type LoginIntegrationRequest = {
  config: string
  user: string
  password: string
  companyId: number
}

const consumeIntegrationSession = (urlSafeToken: string): Promise<any> => {
  if (!urlSafeToken) {
    return Promise.reject('Token mancante')
  }

  return createRequest(
    `/api/integration/consume-session?token=${encodeURIComponent(urlSafeToken)}`,
    'GET',
    undefined,
    undefined
  )
    .then(response => {
      if (!response.ok) {
        throw new Error('Impossibile consumare la sessione o token scaduto')
      }
      return response.json()
    })
    .catch(err => {
      handleErrorCatchLog(err, 'Failed consuming integration session')
      throw err
    })
}

const getOnlyIntegrationToken = async ({
  config,
  user,
  password,
  companyId,
}: LoginIntegrationRequest): Promise<string> => {
  try {
    if (!config) {
      throw new Error('Config mancante')
    }

    if (!user) {
      throw new Error('User mancante')
    }

    if (!password) {
      throw new Error('Password mancante')
    }

    const values: AuthRequest = {
      username: user,
      password,
      companyId: companyId ?? 0,
    }

    const response = await requestToken(config, values)

    if (!response?.token) {
      throw new Error('Token non restituito dalla login')
    }

    setTokenToSessionStorage(response.token)

    return response.token
  } catch (err) {
    handleErrorCatchLog(err, 'Failed getting integration token')
    throw err
  }
}

const getIntegrationOptionPayload = async ({
  utente,
  key,
}: GetIntegrationOptionPayloadRequest): Promise<any> => {
  if (!utente) {
    return Promise.reject('Utente mancante')
  }

  if (!key) {
    return Promise.reject('Key mancante')
  }

  const token = getTokenFromSessionStorage()

  if (!token) {
    return Promise.reject('Token mancante in session storage')
  }

  try {
    const response = await createRequest(
      '/api/integration/option-payload',
      'POST',
      { utente, key },
      token
    )

    if (!response.ok) {
      throw new Error('Impossibile recuperare OptionPayload')
    }

    return response.json()
  } catch (err) {
    handleErrorCatchLog(err, 'Failed getting integration option payload')
    throw err
  }
}

const getPayloadAfterToken = async ({
  config,
  user,
  password,
  companyId,
}: LoginIntegrationRequest): Promise<any> => {
  await getOnlyIntegrationToken({
    config,
    user,
    password,
    companyId,
  })

  return getIntegrationOptionPayload({
    utente: user,
    key: config,
  })
}

export {
  consumeIntegrationSession,
  getOnlyIntegrationToken,
  getIntegrationOptionPayload,
  getPayloadAfterToken,
}